<div class="content">
  <h1>Perguntas frequentes</h1>
  <mat-divider class="divider"></mat-divider>

  <p>
    Tudo o que você precisa saber sobre o Lopes Leads.
    Não consegue achar a resposta para a sua dúvida?
    Por favor, entre em contato com o nosso SAC.
  </p>

  <a (click)="openFaq()">Ir para Perguntas Frequentes</a>
</div>